<template>
  <sc-page :title="title" :loading="!form.ready.value">
    <div class="form-box">
      <widget-form :status="status" :can-toggle="canToggle" :form="form" :groups="groups" :toggle="toggle"
                   @submit="submit"/>
    </div>
  </sc-page>
</template>
<script setup lang="ts">
import {CrudFormService} from "@/components/business/crud/service/CrudFormService";
import WidgetForm from "@/components/business/crud/form/WidgetForm.vue";
import {useQueryParam} from "@/util/queryParam";
import {watch} from "vue";
import {useRoute} from "vue-router";
import {app} from "@/models/App";

const props = defineProps<{
  moduleName: string;
  controllerName: string;
  scene: 'create' | 'update' | 'view';
}>();
// id为主键
const schema = app.data.widgetMap[props.moduleName][props.controllerName];
const route = useRoute();
const primary = route.query[schema.primary]
const queryParam = useQueryParam("readonlyFields");
const service = CrudFormService.create(
    props.moduleName,
    props.controllerName,
    {
      primary: typeof primary === "string" ? primary : undefined,
      status: props.scene === "view" ? "show" : "edit",
    }
)
service.init().then(() => {
  watch(() => queryParam.value, () => {
    service.setReadonlyFields(queryParam.value)
  }, {immediate: true})
})
const {title, form, groups, submit, canToggle, toggle, status} = service.use();

</script>

<style lang="scss" scoped>
.form-box {
  display: flex;
  justify-content: center;
  flex-grow: 1;
  height: 100%;
}
</style>
